import { createSlice } from "@reduxjs/toolkit";
import {
  ServiceGroup,
  Service,
  ServiceProviders,
  ServiceDropDown,
} from "./service.types";
export type ServiceState = {
  readonly display: ServiceGroup | null;
  readonly services: Service[] | null;
  readonly dropdown_services: ServiceDropDown[] | null;
  readonly service_providers: ServiceProviders | null;
};

const INITIAL_STATE: ServiceState = {
  display: null,
  services: null,
  service_providers: null,
  dropdown_services: null,
};
const serviceSlice = createSlice({
  name: "services",
  initialState: INITIAL_STATE,
  reducers: {
    setDisplayServices(state, action) {
      state.display = action.payload;
    },
    setDropdownServices(state, action) {
      state.dropdown_services = action.payload;
    },
    setServices(state, action) {
      state.services = action.payload;
    },
    setServiceProviders(state, action) {
      state.service_providers = action.payload;
    },
  },
});

export const serviceActions = serviceSlice.actions;
export default serviceSlice;
